import * as React from 'react';
export const Instagram = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M7 3.5A3.5 3.5 0 003.5 7v10A3.5 3.5 0 007 20.5h10a3.5 3.5 0 003.5-3.5V7A3.5 3.5 0 0017 3.5H7zM.5 7A6.5 6.5 0 017 .5h10A6.5 6.5 0 0123.5 7v10a6.5 6.5 0 01-6.5 6.5H7A6.5 6.5 0 01.5 17V7z" />
    <path d="M12.41 9.484a2.5 2.5 0 10-.733 4.947 2.5 2.5 0 00.733-4.947zm-2.9-2.409a5.5 5.5 0 115.067 9.764A5.5 5.5 0 019.51 7.075zM16 6.5A1.5 1.5 0 0117.5 5h.01a1.5 1.5 0 010 3h-.01A1.5 1.5 0 0116 6.5z" />
  </svg>
);
